import { FeatureFlag } from '../FeatureFlag';

export const enableThemeSwitching = new FeatureFlag({
    key: 'enable-theme-switching',
    createdOn: '2024-04-20',
    defaultValue: false,
});
